import type {
  ClientOrganizationPushNotificationSetting,
  ClientPushCategoryUserSetting
} from '@DigitaleDoerfer/digitale-doerfer-api';
import type { QueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';

export const getPushCategoriesQueryKey = () => [API_CACHE_KEYS.PUSH_CATEGORIES];

export const getOrganizationCommentPushSettingQueryKey = (
  organizationId: string
) => [API_CACHE_KEYS.ORGANIZATION_COMMENT_PUSH_SETTING, organizationId];

export const setPushCategoryEnabled = (
  queryClient: QueryClient,
  categoryId: string,
  enabled: boolean
) => {
  const queryKey = getPushCategoriesQueryKey();

  queryClient.setQueryData<ClientPushCategoryUserSetting[]>(
    queryKey,
    (settings) =>
      settings?.map((setting) =>
        setting.id === categoryId
          ? { ...setting, loudPushEnabled: enabled }
          : setting
      )
  );
};

export const setOrganizationCommentPushEnabled = (
  queryClient: QueryClient,
  organizationId: string,
  enabled: boolean
) => {
  const queryKey = getOrganizationCommentPushSettingQueryKey(organizationId);

  queryClient.setQueryData<ClientOrganizationPushNotificationSetting>(
    queryKey,
    (setting) => ({
      organizationId,
      ...setting,
      commentPushEnabled: enabled
    })
  );
};
